import { useState } from "react";
import styled from "styled-components";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import Hero from "../components/home/Hero";
import TrustedCompanies from "../components/home/TrustedCompanies";
import TechStacks from "../components/home/TechStacks";
import HiringProcess from "../components/home/HiringProcess";
import WhyProfiles from "../components/home/WhyProfiles";
import ClientTestimonials from "../components/home/ClientTestimonials";
import SkilledDevelopers from "../components/home/SkilledDevelopers";

const Home = () => {
  const [isMenuClicked, setIsMenuClicked] = useState(false);

  return (
    <StyledHome className="styled-home">
      <Header
        isMenuClicked={isMenuClicked}
        setIsMenuClicked={setIsMenuClicked}
      />
      <Hero />
      <TrustedCompanies />
      <TechStacks />
      <HiringProcess />
      <WhyProfiles />
      <ClientTestimonials />
      <SkilledDevelopers />
      <Footer />
    </StyledHome>
  );
};

const StyledHome = styled.div`
  color: #101828;
  font-family: "Inter", sans-serif !important;
  overflow-x: hidden;
`;

export default Home;
